import { Component } from '@angular/core';
import { ControlWidget } from 'ngx-schema-form';
import { MessageService } from 'primeng/primeng';
import { LoyaltyParamsService } from '../../../../..//services/loyalty/params.service';


@Component({
  selector: 'my-custom-image-url-input',
  template: `
    <div class="ui-g-12">
      <div class="ui-g-12 ui-g-nopad sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <input
            type="text"
            pInputText
            class="fieldInput"
            [name]="name"
            [attr.readonly]="schema.readOnly?true:null"
            [attr.id]="id"
            [formControl]="control"
            [attr.placeholder]="schema.placeholder"
            [attr.maxlength]="schema.maxLength||null"
            [attr.minlength]="schema.minLength||null"
            [attr.size]="schema.widget?.size||null"
            [disabled]="schema.readOnly||false"
            [(ngModel)]="imgUrl">
        </div>
        <div class="ui-g-4 ui-md-2">
        <button *ngIf="sec"
            (click)="pasteFromClipboard()"
            pButton
            type="button"
            label="{{'common.pasteFromClipboard' | translate}}">
    </button>
        </div>
        <div class="ui-g-6 ui-md-3">
        <button *ngIf="schema.btnUploadVisible"
        (click)="goToImagesRepository()"
        pButton
        data-testid="OpenImagesRepository"
        type="button"
        label="{{'common.OpenImagesRepository' | translate}}">
</button>
      </div>
      <!-- Anteprima Immagine -->
      <div class="ui-g-12">
        <img [hidden]="!imgUrl" [src]="imgUrl" width="100%" alt="anteprima immagine">
      </div>
    </div>
  `,
  styleUrls: ['./custom-widgets-styles.css']
})
export class ImageUrlWidget extends ControlWidget {
  imgUrl: string;
  sec: boolean = window.isSecureContext;

  constructor(private paramService: LoyaltyParamsService,private srvMessage: MessageService) {
    super()
  }

  async pasteFromClipboard(){
    const copy = await window.navigator['clipboard'].readText();
    this.imgUrl = copy;

  }

  goToImagesRepository(){

    //this.srvMessage.add({ severity: 'info', summary: 'Warning', detail: "Not available!" });


    let storageUserData: any = null;

    if (sessionStorage.getItem('userData')) {
      storageUserData = JSON.parse(sessionStorage.getItem('userData'));
    }
    else if (localStorage && localStorage.getItem("koncentro.userData")){
      storageUserData = JSON.parse(localStorage.getItem('koncentro.userData'))
    }

    if(storageUserData){
      var staticUrl = "/restful/custom/public/koncentro/auth/koncentro?bearer=$access_token$&redirectURL=%2Fadminui/cms/media?path=%2Fftp%2Fcms%2Ffamila%2Fcoupon%2F";
      this.paramService.getParamByKey("IMAGE.REPOSITORY.URL").subscribe(res => {
        if(res){
          staticUrl = staticUrl.replace('$access_token$', storageUserData.token)
          window.open(res.param_code+staticUrl)
        }
        else{
          this.srvMessage.add({ severity: 'error', summary: 'Error', detail: "Error loading IMAGE.REPOSITORY.URL param" });
        }
      })
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/image-url.widget.ts